angular.module('unergie.main')
.controller('defaultProviderOfferModalCtrl', ($scope, $uibModalInstance, DataAccessOffers, AlertManager, ErrorCatcher, BoFeaturesService, energy_type, default_provider_offers, displayOverride) => {
    $scope.defaultProviderOffers = _.cloneDeep(default_provider_offers) || {}
    $scope.energyType = energy_type
    $scope.displayOverride = displayOverride
    $scope.override = true

    $scope.segmentsConf = {
        ELEC: ['C1', 'C2', 'C3', 'C4', 'C5'],
        GAS: ['T1', 'T2', 'T3', 'T4'],
    }

    $scope.conf = {
        epBat: !!_.get($scope.defaultProviderOffers, 'C5.EP'),
    }

    $scope.segments = {}

    DataAccessOffers.getOffers().$promise.then((offers) => {
        $scope.offers = _.orderBy(_.compact(_.map(offers, (m) => ({ value: m.id, label: m.label }))), 'value')
    })

    _.each($scope.defaultProviderOffers, (value, key) => {
        $scope.segments[key] = true
    })


    $scope.changeEpBat = () => {
        _.set($scope.defaultProviderOffers, 'C5', $scope.conf.epBat ? { EP: null, BAT: null } : null)
    }

    const checkEditionOk = () => {
        let ok = true
        _.each(['ELEC', 'GAS'], (energyType) => {
            _.each($scope.segmentsConf[energyType], (seg) => {
                if ($scope.segments[seg]) {
                    if (seg === 'C5' && $scope.conf.epBat) {
                        if (!_.find($scope.offers, { value: $scope.defaultProviderOffers[seg].EP })) {
                            ok = false
                            AlertManager.error(`La valeur de ${seg}.EP ` +
                                `${$scope.defaultProviderOffers[seg].EP ? `"${$scope.defaultProviderOffers[seg].EP}" n'existe pas en base` : `n'est pas renseignée`}.`, 8000)
                        }
                        if (!_.find($scope.offers, { value: $scope.defaultProviderOffers[seg].BAT })) {
                            ok = false
                            AlertManager.error(`La valeur de ${seg}.BAT ` +
                                `${$scope.defaultProviderOffers[seg].BAT ? `"${$scope.defaultProviderOffers[seg].BAT}" n'existe pas en base` : `n'est pas renseignée`}.`, 8000)
                        }
                    } else if (!_.find($scope.offers, { value: $scope.defaultProviderOffers[seg] })) {
                        ok = false
                        AlertManager.error(`La valeur de ${seg} ` +
                            `${$scope.defaultProviderOffers[seg] ? `"${$scope.defaultProviderOffers[seg]}" n'existe pas en base` : `n'est pas renseignée`}.`, 8000)
                    }
                }
            })
        })
        if (!_.find($scope.offers, { value: $scope.defaultProviderOffers.default })) {
            ok = false
            AlertManager.error(`La valeur de l'offre par défaut ` +
                `${$scope.defaultProviderOffers.default ? `"${$scope.defaultProviderOffers.default}" n'existe pas en base` : `n'est pas renseignée`}.`, 8000)
        }
        return ok
    }

    $scope.ok = () => {
        if (!$scope.override) {
            $uibModalInstance.close(null)
        } else if (checkEditionOk()) {
            _.each(['ELEC', 'GAS'], (energyType) => {
                _.each($scope.segmentsConf[energyType], (seg) => {
                    if (!$scope.segments[seg]) {
                        delete $scope.defaultProviderOffers[seg]
                    }
                })
            })
            $uibModalInstance.close($scope.defaultProviderOffers)
        }
    }

    $scope.close = $uibModalInstance.dismiss
})
